import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=f45617fe&scoped=true"
import script from "./SocialButton.vue?vue&type=script&lang=js"
export * from "./SocialButton.vue?vue&type=script&lang=js"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=f45617fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45617fe",
  null
  
)

export default component.exports